import { ApolloClient } from 'apollo-client';

import { UrlQueryInput, UrlQueryResult } from '../types';
import { createDebug } from '../utils/runtimeDebug';

const debug = createDebug('syncReadFromApolloClient');

export function syncReadFromClient(client: ApolloClient<any>, urlKey: string, query: any): UrlQueryResult | undefined {
    try {
        const match = client.readQuery<{ urlResolver: UrlQueryResult }, UrlQueryInput>({
            query,
            variables: {
                urlKey,
            },
        });
        if (match && match.urlResolver) {
            return match.urlResolver;
        } else {
            debug('no match in Apollo client');
        }
    } catch (e) {
        debug('`syncReadFromApolloClient`', e);
        return undefined;
    }
}
